import { Menu } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import { selectUserState } from "../../../store/user/selectors";
import { useDispatch, useSelector } from "react-redux";
import { setKeyValue } from "../../../store/user/slice";

const TenantMenu = () => {
  const { tenants, selectedTenantId, user } = useSelector(selectUserState);

  const dispatch = useDispatch();
  const moreItems = useMemo(
    () => [
      {
        key: "tenant",
        icon: <SwapOutlined />,
        label: "Select Tenant",
        children: [
          ...Object.values(tenants).map((tenant) => ({
            key: tenant.id,
            label: tenant.name,
            onClick: () =>
              dispatch(
                setKeyValue({ key: "selectedTenantId", value: tenant.id }),
              ),
          })),
        ],
      },
    ],
    [user, tenants],
  );

  return (
    <Menu mode="inline" items={moreItems} selectedKeys={[selectedTenantId]} />
  );
};

export default TenantMenu;
